/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showtranscriptioniframe2Inputs */

const en_entity_showtranscriptioniframe2 = /** @type {(inputs: Entity_Showtranscriptioniframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Transcription IFrame`)
};

const de_entity_showtranscriptioniframe2 = /** @type {(inputs: Entity_Showtranscriptioniframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkriptions-IFrame anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Transcription IFrame" |
*
* @param {Entity_Showtranscriptioniframe2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showtranscriptioniframe2 = /** @type {((inputs?: Entity_Showtranscriptioniframe2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showtranscriptioniframe2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showtranscriptioniframe2(inputs)
	return de_entity_showtranscriptioniframe2(inputs)
});
export { entity_showtranscriptioniframe2 as "entity_showTranscriptionIframe" }